import React from 'react';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { useTheme, makeStyles } from '@material-ui/core';
import { styles } from './addButton.styles';

export const AddButton = ({ onClick }) => {
  const currentTheme = useTheme();
  const useStyles = makeStyles(styles(currentTheme));
  const classes = useStyles();
  return (
    <Fab
      variant="extended"
      color="default"
      size="medium"
      className={classes.fabExtended}
      onClick={onClick}
    >
      <AddIcon color="primary" className={classes.fabIcon} />
    </Fab>
  );
};
